import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {ProjectService} from "../project/project.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {
  BrokerApiContractAccountDataModel,
  brokerApiContractAccountDataModelFactory,
  ContractAccountRequests,
} from "../project/project.model";
import {
  accountDeterminationIdLookupConst,
  CONTRACT_ACCOUNT_BILLING_CYCLE_IDS,
  INVOICE_DISTRIBUTION_METHOD_IDS,
  contractAccountCategoryLookupConst,
  correspondenceVariantLookupConst,
  invoiceSchedulingLookupConst,
  paymentTermLookupConst,
  CONTRACT_ACCOUNT_PAYMENT_TERM_OPTIONS_IDS,
  CORRESPONDANCE_VARIAN_IDS,
  INCOMING_PAYMENT_METHOD_IDS,
  CONTRACT_ACCOUNT_CATEGORIES_IDS,
  ACCOUNT_DETERMINATION_IDS,
} from "../types/simplify-constants";
import {CreateContractAccountDialogComponent} from "../workflow/project/create-contract-account-dialog.component";
import {SearchHelpers} from "../helpers/search-helper";
import {CADetailsModel, DeliveryOpsInformationModel} from "../workflow/project/delivery-ops-information.model";
import {transactionStatusValues} from "../types/brokerTransaction";
import {SupportComponent} from "../support/support.component";
import {WorkflowService} from "../workflow/workflow.service";
import {GEO_REGIONS, TARGET_SYSTEM, LATAM_COUNTRIES, GSI_DAAS_TARGET_SYSTEMS, GSI_PMPS_TARGET_SYSTEMS, GSI_MCS_TARGET_SYSTEMS} from "../helpers/app-constants";
import {AppSettingsService} from "../app-settings/app-settings.service";
import {HasuraGraphqlService} from "../graphql/hasura-graphql-service";
import {Query} from "../graphql/query-constant";
import {concat} from "lodash";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 5;

@Component({
  selector: "contract-account-panel",
  templateUrl: "./contract-account-panel.template.pug",
})
export class ContractAccountPanelComponent implements OnInit, OnChanges {
  error: Error;
  private _projectId: string;
  private _contractAccounts: BrokerApiContractAccountDataModel[];
  private _contractAccountsFiltered: BrokerApiContractAccountDataModel[];
  public existingCaName: string [];
  loading: boolean = false;
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";
  POR373_02_flag: boolean = false;
  POR624: boolean = false;
  POR507_TMC: boolean = false;
  POR507_2_1_TMC: boolean = false;
  contractAccountsDisplay: BrokerApiContractAccountDataModel[];
  emptyContractAccount: BrokerApiContractAccountDataModel = brokerApiContractAccountDataModelFactory();
  contractAccountDetail: BrokerApiContractAccountDataModel = brokerApiContractAccountDataModelFactory();
  expandedContractAccountIdName: string = "";
  pendingContractAccountRequests: ContractAccountRequests[] = [];
  mappedCA = [];

  accountDeterminationIdLookup = accountDeterminationIdLookupConst;
  correspondenceVariantLookup = correspondenceVariantLookupConst;
  contractAccountCategoryLookup = contractAccountCategoryLookupConst;
  paymentTermLookup = paymentTermLookupConst;
  invoiceSchedulingLookupConst = invoiceSchedulingLookupConst;

  @Input()
  public set projectId(id: string) {
    this._projectId = id;
  }

  public get projectId() {
    return this._projectId;
  }

  @Input()
  public defaultContractAccountId: string;

  @Input()
  public deliveryInfoForm: DeliveryOpsInformationModel;

  @Input()
  public addressDetails: object;

  @Input()
  public itsmCustomerId: string;

  opportunityId:string;
  @Input()
  public set opportunityID(inputopportunityId: string) {
    if(inputopportunityId){
    this.opportunityId = inputopportunityId; 
    this.setMappedContractAccounts();
    this.adjustContractAccountListHelper(true);
    }
    else
      this.opportunityId = inputopportunityId; 
  }

  @Input()
  public resellerCustomerId: string;

  @Output()
  public contractAccountDetails: EventEmitter<CADetailsModel> = new EventEmitter();

  
  @Input() public disableSelection: boolean = false;

  @Output()
  public mappedContractAccounts: EventEmitter<any> = new EventEmitter();
  
  async ngOnInit() {
    //let por624 = false, por624_tmc = false;
    const featurePermissions = await this.appSettingsService.getFeaturePermissionsList(["POR624", "POR624_TMC", "POR507_TMC","POR507-2-1_TMC"]);
    let [por624, por624_tmc,POR507_2_1_TMC] = [
      featurePermissions["POR624"],
      featurePermissions["POR624_TMC"],
      featurePermissions["POR507-2-1_TMC"]
    ];
    this.POR373_02_flag = true;
    this.POR624 = por624 || por624_tmc;
    this.POR507_2_1_TMC = POR507_2_1_TMC;
    this.POR507_TMC= featurePermissions["POR507_TMC"];
  }

  getDefaultDistributionMethod(country: string): string {
    switch (country) {
      case "IT":
        return INVOICE_DISTRIBUTION_METHOD_IDS.EM1;
      case "TR":
        return INVOICE_DISTRIBUTION_METHOD_IDS.EM3;
      case "CR":
        return "";
      case "CN":
      case "TW":
        return INVOICE_DISTRIBUTION_METHOD_IDS.IDOC;
      case "AU":
      case "NZ":
      case "SG":
      case "HK":
      case "MY":
        return INVOICE_DISTRIBUTION_METHOD_IDS.EM9;
      default:
        return INVOICE_DISTRIBUTION_METHOD_IDS.MAIL;
    }
  }

  getDefaultInvoiceScheduling(country: string, region: string): string {
    let defaultInvoiceScheduling = {
      US: CONTRACT_ACCOUNT_BILLING_CYCLE_IDS.SH03,
      RU: CONTRACT_ACCOUNT_BILLING_CYCLE_IDS.SH30,
    }[country];

    if (!defaultInvoiceScheduling) {
      if (LATAM_COUNTRIES.includes(country)) defaultInvoiceScheduling = CONTRACT_ACCOUNT_BILLING_CYCLE_IDS.SH09;
      else {
        defaultInvoiceScheduling = {
          [GEO_REGIONS.EMEA]: CONTRACT_ACCOUNT_BILLING_CYCLE_IDS.SH05,
          [GEO_REGIONS.APJ]: CONTRACT_ACCOUNT_BILLING_CYCLE_IDS.SH07,
          [GEO_REGIONS.AMS]: CONTRACT_ACCOUNT_BILLING_CYCLE_IDS.SH03,
        }[region];
      }
    }
    return defaultInvoiceScheduling;
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes["projectId"] && changes["projectId"].currentValue) {
      await this.loadAccountList();
      this.refreshAccountList();
    }

    if (changes["defaultContractAccountId"] && this.defaultContractAccountId !== undefined) {
      // this is triggered from selectContractAccount
      this.refreshAccountList();
    }
  }

  constructor(
    public dialogService: DialogService,
    private projectService: ProjectService,
    private workflowService: WorkflowService,
    public appSettingsService: AppSettingsService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {
  }

  setContractAccount(contractAccountId) {
    if (contractAccountId) {
      if (this._contractAccounts && this._contractAccounts.length) {
        const matchingCA = this._contractAccounts.find(({contractAccountId: id}) => id === contractAccountId);
        this.setDefaultCaHelper(matchingCA ? contractAccountId : "");
      }
    } else this.setDefaultCaHelper("");

    this.closeExpandedCaHelper();
    this.adjustContractAccountListHelper();
  }

  mapContractAccount(contractAccountId) {
    if (this.mappedCA.includes(contractAccountId))
      this.mappedCA.splice(this.mappedCA.indexOf(contractAccountId), 1);
    else
      this.mappedCA.push(contractAccountId);
    this.emitMappedCAs();
    this.closeExpandedCaHelper();
    this.adjustContractAccountListHelper();
  }

  private setDefaultCaHelper(id) {
    // Update the form default contract account ID, updating the shadow copy.
    // Only call set on the form control if there is a true difference (to avoid mis-triggering dirty flag detection
    this.defaultContractAccountId = this.deliveryInfoForm.getRawValue().defaultContractAccountId;
    if (id) {
      if (id !== this.defaultContractAccountId) {
        this.deliveryInfoForm.controls["defaultContractAccountId"].setValue(id);
        this.defaultContractAccountId = id;
      }
    } else if (this.defaultContractAccountId) {
      this.deliveryInfoForm.controls["defaultContractAccountId"].setValue("");
      this.defaultContractAccountId = "";
    }
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }
    this.refreshAccountList();
  }

  toggleExpandedContractAccount(caName,caId) {
    const idToUse = caId || caName;
  if (this.expandedContractAccountIdName === idToUse) {
    this.closeExpandedCaHelper();
  } else {
    this.expandedContractAccountIdName = idToUse;
  }

    if (this.expandedContractAccountIdName || !this._contractAccounts || !this._contractAccounts.length) {
      const matchingContractAccount = this._contractAccounts.find(
        ({contractAccountName,contractAccountId}) => (contractAccountId === this.expandedContractAccountIdName) || (contractAccountName === this.expandedContractAccountIdName),
      );

      if (matchingContractAccount) {
        const matchCopy = brokerApiContractAccountDataModelFactory(matchingContractAccount);
        // Now do any human readable value translation
        matchCopy.accountDeterminationId = this.accountDeterminationIdLookup(matchCopy.accountDeterminationId);
        matchCopy.correspondenceVariant = this.correspondenceVariantLookup(matchCopy.correspondenceVariant);
        matchCopy.contractAccountCategory = this.contractAccountCategoryLookup(matchCopy.contractAccountCategory);
        matchCopy.paymentTerms = this.paymentTermLookup(matchCopy.paymentTerms);
        matchCopy.invoiceScheduling = this.invoiceSchedulingLookupConst(matchCopy.invoiceScheduling);
        matchCopy.businessPartner = matchingContractAccount.businessPartner || this.deliveryInfoForm.getRawValue().customerBpId;
        this.contractAccountDetail = matchCopy;
      } else {
        this.closeExpandedCaHelper(); // There are no matches. Clear this out
      }
    } else {
      this.contractAccountDetail = this.emptyContractAccount;
    }
  }

  private getDefaultValuesToContractAccount(targetSystem, payer) {
    let contractAccountDefaultValues: any = {};
    const paymentTerms = Array.isArray(payer.alternatePayer) &&
    payer.alternatePayer.length === 1 && payer.alternatePayer[0].paymentTerms ? payer.alternatePayer[0].paymentTerms : "";
    const gsiPMPS = this.POR373_02_flag && GSI_PMPS_TARGET_SYSTEMS.includes(targetSystem);
    if ([
      TARGET_SYSTEM.DMPS,
      TARGET_SYSTEM.PMPS_PAGE,
      TARGET_SYSTEM.PMPS_COMPLETE,
      TARGET_SYSTEM.MP_FLEX_RESELL,
    ].includes(targetSystem) || gsiPMPS) {
      contractAccountDefaultValues = {
        invoiceDistribuitionMethod: this.getDefaultDistributionMethod(this.workflowService.workflowConfig.countryId),
        invoiceScheduling: this.getDefaultInvoiceScheduling(
          this.workflowService.workflowConfig.countryId,
          this.workflowService.workflowConfig.geoRegionId,
        ),
        paymentTerms: paymentTerms || CONTRACT_ACCOUNT_PAYMENT_TERM_OPTIONS_IDS.NT30,
        correspondenceVariant: CORRESPONDANCE_VARIAN_IDS.Z002,
        correspondenceType: "",
        incomingPaymentMethod: INCOMING_PAYMENT_METHOD_IDS.D,
        outgoingPaymentMethod: "S",
      };

      if ([TARGET_SYSTEM.PMPS_PAGE, TARGET_SYSTEM.PMPS_COMPLETE, TARGET_SYSTEM.MP_FLEX_RESELL].includes(targetSystem)
      || (GSI_DAAS_TARGET_SYSTEMS.includes(targetSystem)) || (GSI_MCS_TARGET_SYSTEMS.includes(targetSystem)) || gsiPMPS) {
        contractAccountDefaultValues.contractAccountCategory = CONTRACT_ACCOUNT_CATEGORIES_IDS.X1;
        contractAccountDefaultValues.accountDeterminationId = ACCOUNT_DETERMINATION_IDS.MP;
      }
    } else if (paymentTerms) {
      contractAccountDefaultValues = {
        paymentTerms,
      };
    }
    return contractAccountDefaultValues;
  }

  private getMPCAddressDetails = (address, caDetail) => {
    const billToParty = Array.isArray(address.buildToParty) ?
      address.buildToParty.find(loca => loca.businessPartnerId === caDetail.billToParty) : null;
    const alternatePayer = Array.isArray(address.alternatePayer) ?
      address.alternatePayer.find(loca => loca.businessPartnerId === caDetail.alternatePayer) : null;
    const caAddress = {
      buildToParty: billToParty ? [billToParty] : address.buildToParty,
      alternatePayer: alternatePayer ? [alternatePayer] : address.alternatePayer,
    };
    return caAddress;
  }

  @handleErrors()
  public async createContractAccount(contractAccountName?, caDetail?): Promise<void> {
    contractAccountName = contractAccountName || "";
    const rawFormValues = this.deliveryInfoForm.getRawValue();
    const targetSystem = this.workflowService.workflowConfig.targetSystem;
    const createContractAccountPresets = {
      businessPartner: rawFormValues.customerBpId,
      projectId:this.projectId
    } as any;
    if (rawFormValues.currency && rawFormValues.currency !== "USD") {
      // keep blank in USD case to allow fedLLC to override
      createContractAccountPresets.currency = rawFormValues.currency;
    }
    if (rawFormValues.companyCodeGroup) createContractAccountPresets.companyCodeGroup = rawFormValues.companyCodeGroup;
    if (rawFormValues.standardCompanyCode) {
      createContractAccountPresets.standardCompanyCode = rawFormValues.standardCompanyCode;
    }

    const gsiPMPS = this.POR373_02_flag  &&
    contractAccountName && GSI_PMPS_TARGET_SYSTEMS.includes(targetSystem);

    if ((contractAccountName && [
      TARGET_SYSTEM.PMPS_PAGE,
      TARGET_SYSTEM.PMPS_COMPLETE,
      TARGET_SYSTEM.MP_FLEX_RESELL,
    ].includes(targetSystem)) ||
      (contractAccountName && GSI_DAAS_TARGET_SYSTEMS.includes(targetSystem)) || (contractAccountName && GSI_MCS_TARGET_SYSTEMS.includes(targetSystem)) || gsiPMPS) {
      createContractAccountPresets.contractAccountName = contractAccountName;
      createContractAccountPresets.projectId = this.projectId;
      createContractAccountPresets.addressDetails = this.getMPCAddressDetails(this.addressDetails, caDetail);
    } else createContractAccountPresets.addressDetails = this.addressDetails;

    createContractAccountPresets.itsmCustomerId = this.itsmCustomerId;
    if(this.POR507_TMC){
      createContractAccountPresets["exchangeRateType"] = "Standard";
    }
    const gsiPMPSBool = this.POR373_02_flag &&
    [TARGET_SYSTEM.PMPS_SELL_THROUGH, TARGET_SYSTEM.PMPS_BILL_THROUGH].includes(targetSystem) &&
    this.resellerCustomerId;

    if (([
      TARGET_SYSTEM.PMPS_PAGE,
      TARGET_SYSTEM.MP_FLEX_RESELL,
      TARGET_SYSTEM.MIGRATION_IPSO_PAGE,
      TARGET_SYSTEM.MP_FLEX_RESELL,
      TARGET_SYSTEM.SELL_THROUGH,
      TARGET_SYSTEM.BILL_THROUGH,
      TARGET_SYSTEM.MCS_SELL_THROUGH,
      TARGET_SYSTEM.MCS_BILL_THROUGH,
      TARGET_SYSTEM.MIGRATION_SELL_THROUGH,
      TARGET_SYSTEM.MIGRATION_BILL_THROUGH,
      TARGET_SYSTEM.MIGRATION_CHANNEL_DAAS,
      TARGET_SYSTEM.CHANNEL_DAAS
    ].includes(targetSystem) && this.resellerCustomerId) || gsiPMPSBool) {
      createContractAccountPresets.resellerCustomerId = this.resellerCustomerId;
    }
    createContractAccountPresets.opportunityId = this.opportunityId;
    createContractAccountPresets.existingCaName = contractAccountName ?
      this.existingCaName.filter(name => name !== contractAccountName.toLowerCase()) : this.existingCaName;

    if (this.addressDetails["soldToOptions"] && this.addressDetails["soldToOptions"].length > 1) {
      // Add soldToOptions to createContractAccountPresets
      createContractAccountPresets.soldToOptions = this.addressDetails["soldToOptions"];
    }

    const defaultValuesToContractAccount =
      this.getDefaultValuesToContractAccount(targetSystem, createContractAccountPresets.addressDetails);
    Object.assign(createContractAccountPresets, defaultValuesToContractAccount);

    const modalResults = await (CreateContractAccountDialogComponent.showDialogModal(
      this.dialogService,
      brokerApiContractAccountDataModelFactory(createContractAccountPresets),
    ).toPromise());
    if (modalResults.create) {
      if (modalResults.updatedPendingCaName) {
        this._contractAccounts.forEach((ca) => {
          if (ca.caStatus && ca.caStatus === "Pending" && ca.contractAccountName === modalResults.updatedPendingCaName) {
            ca.contractAccountName = modalResults.contractAccountName;
            ca.caStatus = "In Progress";
            this.closeExpandedCaHelper();
          }
        });
      }
      const handleContractAccountResult = async (it) => {
        if (it.status === transactionStatusValues.PROCESSING) return; // Keep listening...

        const currentPendingRequest =
          this.pendingContractAccountRequests.find(account => account.filename === modalResults.filename);
        if (currentPendingRequest) {
          if (currentPendingRequest.subscription && !currentPendingRequest.subscription.closed) {
            currentPendingRequest.subscription.unsubscribe(); // We're done listening
          }
          if (it.status === transactionStatusValues.ERROR) {
            currentPendingRequest.error = true;
            currentPendingRequest.statusInformation = it.extras;
            if (contractAccountName) {
              this._contractAccounts.forEach((ca) => {
                if (ca.caStatus && ca.caStatus === "In Progress" && ca.contractAccountName === modalResults.contractAccountName) {
                  ca.caStatus = "Pending";
                }
              });
              this.adjustContractAccountListHelper();
              this.emitCADetails();
            }
          } else if (it.status === transactionStatusValues.SUCCESSFUL) {
            const {updated: caUpdateResult} = await this.projectService.updateContractAccount(modalResults.contractAccountName, "", this.projectId, 1);
            if (!caUpdateResult) {
              this.error = new Error("An unexpected error occurred while updating ca status.");
            }
            if (it.extras && it.extras.messageId) {
              if (contractAccountName) {
                this._contractAccounts.forEach((ca) => {
                  if (ca.caStatus && ca.caStatus === "In Progress" && ca.contractAccountName === modalResults.contractAccountName) {
                    ca.contractAccountId = it.extras.messageId;
                    ca.caStatus = "Active";
                  }
                });
              } else {
                await this.loadAccountList();
                this.refreshAccountList();
              }
              this.addPendingCA();
              this.adjustContractAccountListHelper();
            }
            this.removePendingRequest(currentPendingRequest.filename);
            this.emitCADetails();
          }
        }
      };
      const statusObservable = this.projectService.listenToTransactionStatus(this.projectId, modalResults.filename);

      this.pendingContractAccountRequests.push({
        filename: modalResults.filename,
        subscription: statusObservable.subscribe(handleContractAccountResult),
        error: false,
        statusInformation: null,
        contractAccountName: modalResults.contractAccountName,
      });
      this.emitCADetails();
    } else this.emitCADetails();
  }

  @handleErrors()
  public async removePendingRequest(transactionId) {
    if (this.pendingContractAccountRequests) {
      const currentPendingRequest =
        this.pendingContractAccountRequests.find(it => it.filename === transactionId);
      if (currentPendingRequest) {
        if (currentPendingRequest.subscription && !currentPendingRequest.subscription.closed) {
          currentPendingRequest.subscription.unsubscribe(); // We're done listening
        }
      }
      this.pendingContractAccountRequests =
        this.pendingContractAccountRequests.filter(it => it.filename !== transactionId);
    }
  }

  public addPendingCA() {
    const pendingCA = this._contractAccounts.filter(account => account.caStatus === "Pending");
    this._contractAccounts = [
      ...pendingCA,
      ...this._contractAccounts.filter(account => account.caStatus !== "Pending"),
    ];
  }

  showSupportModal() {
    SupportComponent.showSupportModal(this.dialogService);
  }

  private adjustContractAccountListHelper(orderList = false) {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;

    this.totalCount = this._contractAccounts.length;
    this._contractAccountsFiltered = this._contractAccounts.filter((contractAccount) => {
      if (!contractAccount || !contractAccount.contractAccountName) return false;

      if (this.searchText) {
        const values = [
          contractAccount.contractAccountName,
          contractAccount.contractAccountId,
        ];

        contractAccount.contracts.forEach(a => { values.push(a.opportunityId) });
        

        const searchFailures = SearchHelpers.tokenizeString(this.searchText) // split on spaces but consider "" and ''
          .map(v => SearchHelpers.stripQuotes(v)) // strip quotes on ends if present
          .map(v => SearchHelpers.cleanParam(v)) // sanitize to create regexp
          .map(v => new RegExp(v, "i")) // create regexp
          .map(re => values.some(v => re.test(v))) // test regexp against all asset values
          .filter(it => it === false) // don't care about success
          .length;
        if (searchFailures) return false;
      }

      return true;
    });

    this.totalCount = this._contractAccountsFiltered.length;
    this.maxPages = Math.ceil(this._contractAccountsFiltered.length / (+this.pageSize));

    if (orderList) {
      this.contractAccountsDisplay = [
        ...this._contractAccounts.filter(account => account.contractAccountId === this.defaultContractAccountId),
        ...(this._contractAccountsFiltered.slice(start, end).filter(
          it => it.contractAccountId !== this.defaultContractAccountId, // Prevent duplicates in detail display
        )),
      ];
    }
  }

  private closeExpandedCaHelper() {
    this.expandedContractAccountIdName = ""; // Close any selections
    this.contractAccountDetail = this.emptyContractAccount;
  }

  private async loadAccountList() {
  
    try {
      Query.CA.variables.projectId = this.projectId;
      const params = {
        projectId: this.projectId,
        query: Query.CA,
        uiAction: "LIST-CA",
      };
      const contractAccResult = await this.hasuraGqlService.getResponseFromHasura(params);
      this.loading = true;

      const gsiPMPS = this.POR373_02_flag &&
      (contractAccResult.body.data.project[0].target_system === TARGET_SYSTEM.PMPS_SELL_THROUGH);

      if (contractAccResult && contractAccResult.body && contractAccResult.body.data &&
        contractAccResult.body.data.project && contractAccResult.body.data.project.length > 0) {
        let contractAccountData = contractAccResult.body.data.project[0].target_system === "pmpsp" ||
        contractAccResult.body.data.project[0].target_system === "mimp" ||
        contractAccResult.body.data.project[0].target_system === "mpflexr" ||
        ((
          (contractAccResult.body.data.project[0].target_system === TARGET_SYSTEM.SELL_THROUGH ||
            contractAccResult.body.data.project[0].target_system === TARGET_SYSTEM.MIGRATION_SELL_THROUGH ||
            contractAccResult.body.data.project[0].target_system === TARGET_SYSTEM.MCS_SELL_THROUGH)) ||
            (this.POR624 && [TARGET_SYSTEM.CHANNEL_DAAS,
            TARGET_SYSTEM.MIGRATION_CHANNEL_DAAS].includes(contractAccResult.body.data.project[0].target_system)) ||
            gsiPMPS) ? contractAccResult.body.data.project[0].partnerContractAccounts ?
            contractAccResult.body.data.project[0].partnerContractAccounts.contract_accounts :
            [] : contractAccResult.body.data.project[0].customerContractAccounts ?
            contractAccResult.body.data.project[0].customerContractAccounts.contract_accounts : [];
        contractAccountData = contractAccountData.filter(_contract => _contract.status);
        let pendingCAData = contractAccResult.body.data.project[0].pending_contract_accounts ?
          contractAccResult.body.data.project[0].pending_contract_accounts : [];
        pendingCAData = pendingCAData.filter(_account => _account.contractAccountName && _account.caStatus === 0)
          .map((ca) => ({
            contractAccountName: ca.contractAccountName,
            caStatus: "Pending",
            billToParty: ca.billToParty,
            alternatePayer: ca.alternatePayer,
          }));
        if (pendingCAData && pendingCAData.length > 0) {
          contractAccountData.push(...pendingCAData);
        }
        this._contractAccounts = (contractAccountData || []).sort(this.contractAccountSortHelper);
        this.existingCaName = this._contractAccounts.map(ca => ca.contractAccountName.toLowerCase());
          contractAccountData.forEach((ca) => {
            if (!ca.caStatus) {
              ca.caStatus = ca.status ? "Active" : "Expired";
            }
            if (!ca.businessPartner) {
              ca.businessPartner = this.deliveryInfoForm.getRawValue().customerBpId;
            }
          });
          this.addPendingCA();
        
          this.setMappedContractAccounts();
      
      }
    } catch (error) {
      this.error = new Error(error || "An unexpected error occurred.");
    }
    this.emitCADetails();
    this.loading = false;    
  }
  setMappedContractAccounts() {
    if (this.opportunityId) {
      //check opportunity id mapped with contract account by looping through json
      //if opportunity id matches with current project's opportunity id from input then show selected & disabled
      this._contractAccounts.forEach((ca) => {
        if (ca.contracts && ca.contracts.length > 0) {
          ca.isCASelected = false;
          ca.contracts.forEach((op)=>{
            if(op.opportunityId == this.opportunityId)
            ca.isCASelected = true;
          })            
        }
      });
    }
  }

  private contractAccountSortHelper(a, b) {
    if (!a || !b || !a.contractAccountName || !b.contractAccountName) return 0;
    if (a.contractAccountName > b.contractAccountName) return 1;
    if (a.contractAccountName < b.contractAccountName) return -1;
    return 0;
  }

  private refreshAccountList() {
    if (this._projectId && this._contractAccounts && this._contractAccounts.length > 0) {
      this.adjustContractAccountListHelper(true);
      this.closeExpandedCaHelper();
      this.closeExpandedCaHelper();
    }
    this.emitCADetails();
  }

  async rejectCA(caName) {
    const {updated: caUpdateResult} = await this.projectService.updateContractAccount(caName, "", this.projectId, 2);
    if (caUpdateResult) {
      this._contractAccounts = this._contractAccounts.filter(({contractAccountName}) => contractAccountName !== caName);
      this.emitCADetails();
    }
    this.adjustContractAccountListHelper(true);
    if (!caUpdateResult) {
      this.error = new Error("An unexpected error occurred while updating ca status.");
    }
  }

  public async reloadContractAccounts(){
    await this.loadAccountList();
    this.mappedCA = [];
    this.emitMappedCAs();
    this.refreshAccountList();
  }

  public emitCADetails() {
    this.contractAccountDetails.emit({
      activeCAExists: !!(this._contractAccounts && this._contractAccounts.length &&
        this._contractAccounts.some(pca => pca.caStatus !== "Pending")),
      pendingCADetails: this.pendingContractAccountRequests && this.pendingContractAccountRequests.length ?
        this.pendingContractAccountRequests : [],
      pendingCAExists: (this._contractAccounts && this._contractAccounts.some(pca => pca.caStatus === "Pending")) || false,
    });
  }

  public emitMappedCAs(){
    this.mappedContractAccounts.emit(this.mappedCA);
  }

  public checkCAMappingRequired() {
    let isRequiredMappingPresent = true;
    if ((!this.mappedCA || this.mappedCA.length <= 0) && !this._contractAccounts.some(ca => ca.isCASelected == true))
      isRequiredMappingPresent = false;
    return isRequiredMappingPresent;
  }

  ngOnDestroy() {
    if (this.pendingContractAccountRequests) {
      this.pendingContractAccountRequests.forEach(({subscription}) => {
        if (subscription && !subscription.closed) subscription.unsubscribe();
      });
    }
  }
}
